import { useEffect } from "react";

export default function AdminRedirect() {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/admin`;
  }, []);
  return <div className="mx-auto max-w-lg px-4 py-24 text-center text-[var(--yp-muted)]">Redirecting to admin…</div>;
}
